// Store custom colors with representative names here.
// Use in local variables within each theme-file

/**
 * This file is copied from drops-frontend
 */
export const appPalette = {
  // Green
  green25: "#E8F6F1",
  green50: "#E5F4F1",
  // Teal
  teal25: "#E1E7E7",
  tealGrey50: "#F2F3F3",
  teal50: "#ECF3EF",
  tealGreen100: "#D7EADE",
  teal100: "#D7E0DE",
  teal200: "#CCD8D6",
  teal300: "#AEC0BE",
  teal400: "#9AB0AD",
  teal500: "#688985",
  teal600: "#35625C",
  teal700: "#00453E",
  teal800: "#012925",
  teal900: "#001F1C",
  teal1000: "#001A18",
  teal1100: "#001211",
  teal1200: "#010B0A",
  // Violet
  violet50: "#EEEFFD",
  violet100: "#DEDFFC",
  violet200: "#CDCFFA",
  violet300: "#C0C0F9",
  violet400: "#ABAFF7",
  violet500: "#8287F3",
  violet600: "#585FEF",
  violet700: "#4247B3",
  violet800: "#2C3078",
  violet900: "#1A1D48",
  violet1000: "#121330",
  violet1100: "#090A18",
  // Expansions
  wine: "#99002E",
  raspberry: "#CC003D",
  rose: "#FF3370",
};
